export default __webpack_public_path__ + "static/media/002.b7e6252a.jpg";